// src/js/main.js

import $ from './plugins/jquery-global';

await import('bootstrap4');
await import('magnific-popup');
await import('devbridge-autocomplete');

import favHandler from './modules/favorites';
import './modules/map';

$.fn.overflown = function() {
    const e = this[0];
    return e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth;
};

window.isInitialized = false;

window.sha256Hash = async function sha256Hash(value) {
    const data = new TextEncoder().encode(value);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray
        .map((bytes) => bytes.toString(16).padStart(2, '0'))
        .join('');
};

const config = {
    topOffsetDesktop: 135,
    topOffsetMobile: 50,
    minWidth: 750
};

function debounce(func, wait, immediate) {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

function handleNavigation(hasAnchorNav) {
    // mobile nav
    if (config.windowWidth < config.minWidth) {
        $('#mobile-nav').on('show.bs.collapse', function() {
            $('button.hamburger').addClass('is-active');
        }).on('hide.bs.collapse', function() {
            $('button.hamburger').removeClass('is-active');
        });
    }

    // navs and scrolling
    $(window).on('scroll', debounce(function() {
        // man navigation
        const scrollTop = $(this).scrollTop();
        const headerHeight = config.headerContainer.height();
        // main navigation
        if (config.navbarContainer.hasClass('header-navbar--fixed') && (scrollTop < 50 || config.windowWidth < config.minWidth)) {
            config.navbarContainer.removeClass('header-navbar--fixed');
        } else if (!config.navbarContainer.hasClass('header-navbar--fixed') && config.windowWidth > config.minWidth && scrollTop > headerHeight) {
            config.navbarContainer.css('opacity', 0);
            config.navbarContainer.addClass('header-navbar--fixed');
            config.navbarContainer.animate({ opacity: 1 });
        }

        // anchor navigation
        if (hasAnchorNav) {
            // anchor navbar state
            if (!config.anchorNavContainer.length) {
                return;
            }
            if (config.anchorNavContainer.hasClass('anchor-nav--fixed') && scrollTop < config.anchorNavTopOffset) {
                config.anchorNavContainer.removeClass('anchor-nav--fixed');
            } else if (!config.anchorNavContainer.hasClass('anchor-nav--fixed') && scrollTop > config.anchorNavTopOffset) {
                config.anchorNavContainer.css('opacity', 0);
                config.anchorNavContainer.addClass('anchor-nav--fixed');
                config.anchorNavContainer.animate({ opacity: 1 });
            }

            // active anchor nav items
            const scrollDistance = $(window).scrollTop() + 200;
            // assign active class to nav links while scolling
            $('.page-section').each(function(i) {
                if ($(this).position().top <= scrollDistance) {
                    $('.nav-anchors a.active').removeClass('active');
                    $('.nav-anchors a').eq(i).addClass('active');
                }
            });
        }
    }, 100));

    // anchor nav clicks
    if (hasAnchorNav) {
        $('a.anchor').bind('click', function(e) {
            e.preventDefault(); // prevent hard jump, the default behavior
            let stickyNavsHeight = 135;

            if ($(this).hasClass('home')) {
                config.anchorNavContainer.removeClass('anchor-nav--fixed');
                stickyNavsHeight = 50;
            } else {
                // first set both sticky (to get correct offset)
                if ($(this).width() > 750 && !config.navbarContainer.hasClass('header-navbar--fixed')) {
                    config.navbarContainer.css('opacity', 0);
                    config.navbarContainer.addClass('header-navbar--fixed');
                    config.navbarContainer.animate({ opacity: 1 });
                }
                if (!config.anchorNavContainer.hasClass('anchor-nav--fixed')) {
                    config.anchorNavContainer.css('opacity', 0);
                    config.anchorNavContainer.addClass('anchor-nav--fixed');
                    config.anchorNavContainer.animate({ opacity: 1 });
                }
            }

            const target = $(this).attr('href'); // Set the target as variable
            const targetTopOffset = $(target).offset().top - stickyNavsHeight;
            // perform animated scrolling by getting top-position of target-element and set it as scroll target
            $('html, body').stop().animate({
                scrollTop: targetTopOffset
            }, 600);

            return false;
        });
    }
}

function handleShowMoreButtons() {
    if ($('.itinerary-desc.js-reduced').length && $('.itinerary-desc.js-reduced').overflown()) {
        $('.js-fullitinerary').show(200);
    }
    $('.js-fullitinerary').on('click', function() {
        const itineraryDescElem = $('.itinerary-desc');
        let oldText = '';
        if (itineraryDescElem.hasClass('js-reduced')) {
            itineraryDescElem.toggleClass('js-reduced');
            oldText = $(this).html();
            $(this).html($(this).data('alttext'));
            $(this).data('alttext', oldText);
        } else {
            itineraryDescElem.toggleClass('js-reduced');
            oldText = $(this).html();
            $(this).html($(this).data('alttext'));
            $(this).data('alttext', oldText);
        }
    });

    $('.js-fullinterest').on('click', function() {
        const interestDescElemId = $(this).data('id');
        const itineraryDescElem = $('#' + interestDescElemId);
        if (itineraryDescElem) {
            let oldText = '';
            if (itineraryDescElem.hasClass('js-reduced')) {
                itineraryDescElem.toggleClass('js-reduced');
                oldText = $(this).html();
                $(this).html($(this).data('alttext'));
                $(this).data('alttext', oldText);
            } else {
                itineraryDescElem.toggleClass('js-reduced');
                oldText = $(this).html();
                $(this).html($(this).data('alttext'));
                $(this).data('alttext', oldText);
            }
        }
    });
}

function handleSmoothScroll() {
    $(document).on('click', 'a.js-smscroll', function(e) {
        e.preventDefault();
        const target = $($(this).attr('href'));

        if (!target.length) return;

        $('html, body').animate({
            scrollTop: target.offset().top - 120
        }, 500, 'linear');
    });
}

function handleProductGalleries() {
    $('.magnific-slideshow').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true,
            preload: [1, 2]
        },
        callbacks: {
            beforeOpen: function() {
                const mfp = this;
                this.items = [];
                $(this.st.el.children('div')[0]).children().each(function(i) {
                    mfp.items.push({
                        src: $(this).data('mfpSrc'),
                        type: 'image',
                        caption: $(this).data('mfpCaption')
                    });
                });
            }
        },
        image: {
            titleSrc: function(item) {
                if (item.data.caption) {
                    return item.data.caption;
                } else {
                    return '';
                }
            }
        }
    });

    // open gallery from shown images
    $('.mfp-gallery-open').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true,
            preload: [0, 1]
        },
        callbacks: {
            beforeOpen: function() {
                const mfp = this;
                this.items = [];
                $('.mfp-gallery-collection').children().each(function(i) {
                    mfp.items.push({
                        src: $(this).data('mfpSrc'),
                        type: 'image',
                        caption: $(this).data('mfpCaption')
                    });
                });
                $.magnificPopup.instance.next();
            }
        },
        image: {
            titleSrc: function(item) {
                if (item.data.caption) {
                    return item.data.caption;
                } else {
                    return '';
                }
            }
        }
    });
}

function handleProductVideoGallery() {
    if (window.ucDps.youtubeVideo) {
        $('.youtube-videos').each(function() {
            if ($(this).data('href')) {
                $(this).attr('href', $(this).data('href'));
                $(this).removeAttr('data-href');
                $(this).off('click');
            }
        });

        $('.youtube-videos').magnificPopup({
            type: 'iframe',
            iframe: {
                patterns: {
                    youtube: {
                        index: 'youtube.com',
                        id: 'v=',
                        src: '//www.youtube.com/embed/%id%?rel=0'
                    }
                }
            }
        });
    } else {
        $('.youtube-videos').each(function() {
            $(this).data('href', $(this).attr('href'));
            $(this).removeAttr('href');
            $(this).on('click', function() {
                // eslint-disable-next-line no-undef
                UC_UI.showSecondLayer();
            });
        });
    }
}

function adaptIFrameElement(elem, consentIsGiven, noConsentMsg) {
    if (consentIsGiven) {
        if (elem.dataset.src) {
            elem.src = elem.dataset.src;
            elem.parentElement.classList.remove('no-consent');
            const noConsentInfo = elem.parentElement.querySelector('.no-consent-info');
            if (noConsentInfo) {
                noConsentInfo.remove();
            }
        }
    } else {
        if (!elem.dataset || !elem.dataset.src) {
            elem.dataset.src = elem.src;
        }
        elem.src = '';

        const noConsentInfo = document.createElement('div');
        noConsentInfo.innerHTML = noConsentMsg;
        noConsentInfo.className = 'no-consent-info';
        elem.parentElement.append(noConsentInfo);

        elem.parentElement.classList.add('no-consent');
    }
}

function handleConsentManagement() {
    //  Defined Data Processing Services
    window.ucDps = {
        googleMaps: false,
        youtubeVideo: false
    };
    //  Handle consent status changes
    window.addEventListener('onConsentStatusChange', (event) => {
        const dpsGoogleMaps = 'Google Maps';
        const dpsYoutubeVideo = 'YouTube Video';

        let consentBlockedMsg = 'Der Inhalt wurde aufgrund der gewählten <a onclick="UC_UI.showSecondLayer();">Datenschutzeinstellungen</a> blockiert.';
        if (document.documentElement.lang.substring(0, 2) === 'fr') {
            consentBlockedMsg = 'Le contenu a été bloqué en raison des <a onclick="UC_UI.showSecondLayer();">paramètres de confidentialité</a> choisis.';
        }
        if (event.detail && event.detail.event && event.detail.event === 'consent_status') {
            // GoogleMaps
            if (dpsGoogleMaps in event.detail) {
                window.ucDps.googleMaps = !!event.detail[dpsGoogleMaps];
            }
            const gmapIframes = document.querySelectorAll('iframe.gmap');
            if (gmapIframes.length) {
                gmapIframes.forEach((iFrameElem) => {
                    adaptIFrameElement(iFrameElem, window.ucDps.googleMaps, consentBlockedMsg);
                });
            }

            // YouTube
            if (dpsYoutubeVideo in event.detail) {
                window.ucDps.youtubeVideo = !!event.detail[dpsYoutubeVideo];
            }
            const ytIframes = document.querySelectorAll('iframe.yt-video');
            if (ytIframes.length) {
                ytIframes.forEach((iFrameElem) => {
                    adaptIFrameElement(iFrameElem, window.ucDps.youtubeVideo, consentBlockedMsg);
                });
            }

            handleProductVideoGallery();
        }

        // dispatch event
        const consentEvent = new CustomEvent('consentStatusSet', {});
        document.dispatchEvent(consentEvent);
    });
}

class SuggestController {
    init() {
        $('form[data-suggest]').each(function() {
            const $form = $(this);
            let $searchBox = $form.find('.tx-solr-suggest');
            const $searchIcon = $form.find('i.material-icons');
            $form.find('.tx-solr-suggest-focus').focus();
            $.ajaxSetup({ jsonp: 'tx_solr[callback]' });

            // when no specific container found, use the form as container
            if ($searchBox.length === 0) {
                $searchBox = $form;
            }
            $searchBox.css('position', 'relative');

            // Prevent submit of empty search form
            $form.on('submit', function(e) {
                if ($form.find('.tx-solr-suggest').val() === '') {
                    e.preventDefault();
                    window.location = $form.attr('action');
                }
            });
            $form.find('.tx-solr-suggest').devbridgeAutocomplete({
                serviceUrl: $form.data('suggest'),
                dataType: 'jsonp',
                paramName: 'tx_solr[queryString]',
                groupBy: 'category',
                maxHeight: 320,
                autoSelectFirst: false,
                triggerSelectOnValidInput: false,
                width: $searchBox.outerWidth(),
                onSelect: function(suggestion) {
                    // go to link when selecting found result
                    if (suggestion.data.link) {
                        // Open youtube in overlay
                        if (suggestion.data.link.indexOf('https://www.youtube.com') === 0) {
                            openVideoOverlay(suggestion.data.link);
                        } else {
                            location.href = suggestion.data.link;
                        }
                        // else trigger form submit (do search)
                    } else {
                        $form.trigger('submit');
                    }
                },
                transformResult: function(response) {
                    if (!response.suggestions) return { suggestions: [] };
                    let firstSuggestion;
                    const result = {
                        suggestions: $.map(response.suggestions, function(count, suggestion) {
                            if (!firstSuggestion) firstSuggestion = suggestion;
                            return { value: suggestion, data: { category: 'suggestion', count: count } };
                        })
                    };
                    $.each(response.documents, function(key, value) {
                        const dataObject = value;

                        // var defaultGroup = $form.data('suggest-header') ? $form.data('suggest-header') : 'Top results';
                        dataObject.category = $form.data('suggest-header') ? $form.data('suggest-header') : 'Top results';

                        // if a group is set we try to get a label
                        if (dataObject.group) {
                            dataObject.category = $form.data('suggest-header-' + dataObject.group) ? $form.data('suggest-header-' + dataObject.group) : dataObject.group;
                        }

                        result.suggestions.push(
                            {
                                value: firstSuggestion,
                                data: dataObject
                            }
                        );
                    });
                    return result;
                },
                beforeRender: function(container) {
                    // change first group header title
                    // if ( $form.data('suggest-header-suggestion') ) {
                    //    container.find('.autocomplete-group:first').html($form.data('suggest-header-suggestion'));
                    // }
                    // remove first group header
                    container.find('.autocomplete-group:first').remove();
                    container.addClass('tx-solr-autosuggest');

                    // add active class to container
                    $searchBox.parent().addClass('autocomplete-active').fadeIn();
                },
                formatResult: function(suggestion, currentValue) {
                    // Do not replace anything if there current value is empty
                    if (!currentValue) {
                        return suggestion.value;
                    }
                    const pattern = '(' + $.Autocomplete.utils.escapeRegExChars(currentValue.trim()) + ')';
                    // normal suggestion
                    if (suggestion.data.category === 'suggestion') {
                        return suggestion.value
                            .replace(new RegExp(pattern, 'gi'), '<strong>$1</strong>')
                            .replace(/&/g, '&amp;')
                            .replace(/</g, '&lt;')
                            .replace(/>/g, '&gt;')
                            .replace(/"/g, '&quot;')
                            .replace(/&lt;(\/?strong)&gt;/g, '<$1>');

                        // results
                    } else {
                        const title = suggestion.data.title
                            .replace(new RegExp(pattern, 'gi'), '<em>$1</em>')
                            .replace(/&/g, '&amp;')
                            .replace(/</g, '&lt;')
                            .replace(/>/g, '&gt;')
                            .replace(/"/g, '&quot;')
                            .replace(/&lt;(\/?em)&gt;/g, '<$1>');

                        return '<div class="autocomplete-restype ' + suggestion.data.type + '">'
                            + (suggestion.data.previewImage ? '<figure ' + (suggestion.data.hasVideo ? 'class="hasVideo"' : '') + '><img alt="" src="' + suggestion.data.previewImage + '" /></figure>' : '')
                            + '<a href="' + suggestion.data.link + '" class="internal-link">' + title + '</a>'
                            + '</div>';
                    }
                },
                onSearchStart: function(params) {
                    if (!$searchIcon.hasClass('loading')) {
                        $searchIcon.addClass('loading');
                        $searchIcon.html('<div></div><div></div><div></div><div></div>');
                    }
                },
                onSearchComplete: function(query, suggestions) {
                    $searchIcon.removeClass('loading');
                    $searchIcon.html('search');
                }
            }).on('blur', function() {
                $searchBox.parent().removeClass('autocomplete-active');
                const $box = $(this);
                setTimeout(function() {
                    $box.devbridgeAutocomplete('hide');
                }, 200);
            });
        });
    }
}

class SearchController {
    constructor() {
        this.ajaxType = 7383;
    }

    init() {
        $('body').on('click', 'a.solr-ajaxified', (e) => {
            e.preventDefault();
            this.handleClick(e.currentTarget);
        });
    }

    handleClick(link) {
        const $link = $(link);
        const container = $link.closest('.tx_solr');
        const solrParent = container.parent();
        const uri = `${$link.attr('href')}&type=${this.ajaxType}`;

        $('#filter-mobile').collapse('hide');

        $('.solr-loading').show();
        this.scrollToTopOfElement(solrParent, 75);

        $.get(uri, (data) => {
            container.replaceWith(data);
            $('body').trigger('tx_solr_updated');
        });
    }

    scrollToTopOfElement(element, deltaTop) {
        $('html, body').animate({
            scrollTop: (element.offset().top - deltaTop) + 'px'
        }, 'slow');
    }

    handleSelectOptionSelection(elem) {
        let solrContainer = $('select.region-dropdown').closest('.tx_solr');
        const solrParent = solrContainer.parent();
        let uri = elem.value;
        uri += '&type=' + this.ajaxType;

        $('#filter-mobile').collapse('hide');

        $('.solr-loading').show();
        this.scrollToTopOfElement(solrParent, 75);

        $.get(
            uri, // uri.href(),
            function(data) {
                solrContainer = solrContainer.replaceWith(data);
                $('body').trigger('tx_solr_updated');
            }
        );
        return false;
    }
}

/**
 * Load plugins/modules async
 */
async function slickLoader() {
    const slickBanners = document.getElementsByClassName('slick-banner');
    if (slickBanners.length > 0) {
        await import('./plugins/inspiration');
    }
}

async function dateRangePickerLoader() {
    const dateRangePickerInputs = document.getElementsByClassName('from-control-datesingle');
    if (dateRangePickerInputs.length > 0) {
        await import('./plugins/daterangepicker');
    }
}

async function matchHeightLoader() {
    const simpleTeasers = document.getElementsByClassName('simple-teaser');
    const topicTeasers = document.getElementsByClassName('topic-teaser');
    const productTeasers = document.getElementsByClassName('product-teaser');
    if (simpleTeasers.length > 0 || topicTeasers.length > 0 || productTeasers.length > 0) {
        await import('./plugins/matchheight');
    }
}

async function select2Loader() {
    const select2Elems = document.getElementsByClassName('facet-type-hierarchy');
    if (select2Elems.length > 0) {
        await import('./plugins/select2');
    }
}

/**
 * main entry point
 */
function workOnDom() {
    const bodySelector = $('body');
    const anchorNavSelector = $('#anchor-nav-anchor');
    $.extend(config, {
        headerContainer: $('.header'),
        navbarContainer: $('.header-navbar'),
        anchorNavContainer: $('.anchor-nav'),
        windowWidth: bodySelector.width(),
        anchorNavTopOffset: anchorNavSelector.length ? anchorNavSelector.offset().top : 0
    });

    handleNavigation(anchorNavSelector.length);
    handleConsentManagement();

    handleShowMoreButtons();
    handleSmoothScroll();
    handleProductGalleries();

    // modules
    favHandler.init();

    // solr
    window.solrSuggestController = new SuggestController();
    window.solrSuggestController.init();

    window.solrSearchController = new SearchController();
    window.solrSearchController.init();

    // re-init after ajax updates
    $('body').on('tx_solr_updated', () => {
        window.solrSuggestController.init();
        favHandler.setFavToggleState();
        favHandler.handleFavToggleClicks();
    });

    slickLoader().then(() => null).catch(() => null);
    dateRangePickerLoader().then(() => null).catch(() => null);
    matchHeightLoader().then(() => null).catch(() => null);
    select2Loader().then(() => null).catch(() => null);

    // initial triggers
    $(window).trigger('scroll');
    $(window).trigger('resize');

    // dispatch event initialization finished
    const initEvent = new CustomEvent('initialized', {});
    document.dispatchEvent(initEvent);
    window.isInitialized = true;
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => workOnDom());
} else {
    workOnDom();
}

// export default {};
